function frozenSlider(img) {
  const viewport=document.createElement('div');
  viewport.className='frozen-slide-viewport';
  img.before(viewport);viewport.appendChild(img);
  let request=0,cleanup=()=>{};
  return async function(src,alt,direction=1) {
    const ticket=++request;
    if(img.getAttribute('src')===src){img.alt=alt;return;}
    const preload=new Image();preload.src=src;
    try {await preload.decode();}catch(error){return;}
    if(ticket!==request||!img.isConnected)return;
    cleanup();
    if(!img.animate||window.matchMedia('(prefers-reduced-motion: reduce)').matches){img.src=src;img.alt=alt;return;}
    const previous=img.cloneNode(false);
    previous.removeAttribute('id');previous.removeAttribute('fetchpriority');
    previous.alt='';previous.setAttribute('aria-hidden','true');
    previous.classList.add('frozen-slide-outgoing');viewport.appendChild(previous);
    img.src=src;img.alt=alt;
    const offset=direction<0?-100:100;
    const options={duration:650,easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'};
    const incoming=img.animate([{transform:'translateX('+offset+'%)'},{transform:'translateX(0)'}],options);
    const outgoing=previous.animate([{transform:'translateX(0)'},{transform:'translateX('+(-offset)+'%)'}],options);
    const finish=()=>{incoming.cancel();outgoing.cancel();previous.remove();};
    cleanup=finish;
    Promise.all([incoming.finished,outgoing.finished]).then(finish,()=>{});
  };
}
function frozenColor(value) {
  const text=String(value).toLowerCase();
  if (/white|hvit|vit/.test(text)) return 'white';
  if (/navy|marine|mørkeblå|dark blue/.test(text)) return 'navy';
  if (/light blue|ice blue|lyseblå|blue|ice|blå/.test(text)) return 'blue';
  if (/red|rød/.test(text)) return 'red';
  if (/beige|sand|tan/.test(text)) return 'beige';
  if (/pink|rosa/.test(text)) return 'pink';
  if (/black|svart|sort/.test(text)) return 'black';
  return null;
}
function frozenSize(value) {
  const text=String(value).toUpperCase().replace(/[\s_-]/g,'');
  return ({XS:'XS',EXTRASMALL:'XS',S:'S',SMALL:'S',M:'M',MEDIUM:'M',L:'L',LARGE:'L',XL:'XL',EXTRALARGE:'XL',XXL:'XXL','2XL':'XXL',XXLARGE:'XXL',EXTRAEXTRALARGE:'XXL'})[text] || null;
}
function frozenMatch(variants,color,size,base) {
  return variants.find(v=>v.options.some(x=>frozenColor(x)===color) && v.options.some(x=>frozenSize(x)===size) && v.options.every((x,i)=>frozenColor(x)||frozenSize(x)||x===base[i]));
}
async function frozenAjaxCartSubmit(event) {
  const form=event.target;
  if(!(form instanceof HTMLFormElement)||!form.matches('.product form[action*="/cart/add"]')||event.defaultPrevented)return;
  const submitter=event.submitter;
  if(submitter&&!submitter.matches('[name="add"],[data-add],[data-jacket-add],[data-beanie-add]'))return;
  const idField=form.querySelector('[name="id"]');
  const quantityField=form.querySelector('[name="quantity"]');
  const variantId=idField&&idField.value;
  if(!variantId)return;
  event.preventDefault();
  const addButton=submitter||form.querySelector('[name="add"],[data-add],[data-jacket-add],[data-beanie-add]');
  const previousText=addButton?addButton.textContent:'';
  if(addButton){addButton.disabled=true;addButton.textContent='ADDING…';}
  try{
    const root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
    const response=await fetch(root+'cart/add.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:Number(variantId),quantity:Math.max(1,Number(quantityField&&quantityField.value)||1)}]})
    });
    if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||error.message||'Unable to add this item.');}
    window.location.assign(root+'cart');
  }catch(error){
    const status=form.querySelector('[data-status],[data-jacket-status],[data-beanie-status]');
    if(status){status.textContent=error.message;status.focus();}
    if(addButton){addButton.disabled=false;addButton.textContent=previousText||'ADD TO CART';}
  }
}
function initializeFrozenProduct(root) {
  if(root.dataset.initialized) return;
  const variants=JSON.parse(root.querySelector('[data-variants]').textContent);
  const galleries=JSON.parse(root.querySelector('[data-galleries]').textContent);
  const select=root.querySelector('[data-variant-select]');
  const initial=variants.find(v=>String(v.id)===select.value)||variants[0];
  const base=initial ? initial.options : [];
  let color=base.map(frozenColor).find(Boolean)||'blue';
  let size=base.map(frozenSize).find(Boolean)||'S';
  let view=0;
  const main=root.querySelector('.mainpic');
  const slide=frozenSlider(main);
  Object.values(galleries).flat().forEach(src=>{const image=new Image();image.src=src;});
  const stage=root.querySelector('.gallery-stage');
  const names=['Front','Side','Back'];
  const thumbs=Array.from(root.querySelectorAll('[data-thumb]'));
  const colors=Array.from(root.querySelectorAll('[data-color]'));
  const sizes=Array.from(root.querySelectorAll('[data-size]'));
  const preorder=root.hasAttribute('data-preorder');
  function gallery(direction=1) {
    const labels={blue:'Light blue',white:'White',red:'Red',beige:'Beige',pink:'Pink',black:'Black',navy:'Navy blue'};
    const label=labels[color]||'Light blue';
    slide(galleries[color][view],label+' pants — '+names[view].toLowerCase()+' view',direction);
    root.querySelector('[data-view]').textContent=names[view]+' · '+(view+1)+' / 3';
    thumbs.forEach((link,i)=>{
      link.href=galleries[color][i];
      link.querySelector('img').src=galleries[color][i];
      link.querySelector('img').alt=label+' pants — '+names[i].toLowerCase()+' view';
      link.setAttribute('aria-current',String(i===view));
    });
  }
  function sync(updateUrl=false) {
    const variant=frozenMatch(variants,color,size,base);
    const available=!!variant && (variant.available||preorder);
    select.value=variant?String(variant.id):'';
    root.querySelector('[data-add]').disabled=!available;
    root.querySelector('[data-add]').textContent=available?'ADD TO CART':variant?'SOLD OUT':'UNAVAILABLE';
    root.querySelector('[data-express]').hidden=!available;
    root.querySelector('[data-status]').textContent=available?'':variant?'This size is sold out in this color.':'This color and size is not available.';
    const option=Array.from(select.options).find(o=>variant && o.value===String(variant.id));
    root.querySelector('[data-price]').textContent=option?option.dataset.price:'';
    colors.forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.color===color)));
    sizes.forEach(b=>{
      const candidate=frozenMatch(variants,color,b.dataset.size,base);
      b.setAttribute('aria-pressed',String(b.dataset.size===size));
      const candidateAvailable=!!candidate&&(candidate.available||preorder);
      b.classList.toggle('is-unavailable',!candidateAvailable);
      b.setAttribute('aria-label',b.dataset.size+(!candidate?' — unavailable':!candidateAvailable?' — sold out':''));
    });
    root.querySelector('[data-color-label]').textContent=({blue:'Light Blue',white:'White',red:'Red',beige:'Beige',pink:'Pink',black:'Black',navy:'Navy Blue'})[color]||'Light Blue';
    if(updateUrl) {
      const url=new URL(window.location.href);
      if(variant) url.searchParams.set('variant',variant.id);else url.searchParams.delete('variant');
      history.replaceState({},'',url);
      select.dispatchEvent(new Event('change',{bubbles:true}));
    }
  }
  colors.forEach(b=>b.addEventListener('click',()=>{color=b.dataset.color;view=0;gallery();sync(true);}));
  sizes.forEach(b=>b.addEventListener('click',()=>{size=b.dataset.size;sync(true);}));
  const move=delta=>{view=(view+delta+3)%3;gallery(delta);};
  thumbs.forEach((link,i)=>link.addEventListener('click',event=>{event.preventDefault();view=i;gallery();}));
  root.querySelector('[data-prev]').addEventListener('click',()=>move(-1));
  root.querySelector('[data-next]').addEventListener('click',()=>move(1));
  stage.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}});
  let touchStart=null;
  stage.addEventListener('touchstart',event=>{touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};},{passive:true});
  stage.addEventListener('touchend',event=>{
    if(!touchStart)return;
    const dx=event.changedTouches[0].clientX-touchStart.x,dy=event.changedTouches[0].clientY-touchStart.y;
    if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy))move(dx<0?1:-1);
    touchStart=null;
  },{passive:true});
  root.querySelector('form').addEventListener('submit',event=>{
    const variant=frozenMatch(variants,color,size,base);
    if(!variant||(!variant.available&&!preorder)){event.preventDefault();root.querySelector('[data-status]').focus();}
  });
  root.querySelector('[data-status]').tabIndex=-1;
  root.querySelector('[data-picker]').hidden=false;
  root.querySelector('[data-native-picker]').hidden=true;
  root.querySelector('.gallery-controls').hidden=false;
  root.dataset.initialized='true';
  gallery();sync();
  frozenAutoplay(root.querySelector('.product-gallery'),()=>move(1),root.querySelector('[data-view]'));
}
function frozenAutoplay(surface,advance,announcement) {
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const button=document.createElement('button');
  button.type='button';button.className='gallery-play';
  surface.appendChild(button);
  let paused=motion.matches,hovered=false,timer=null;
  const controller=new AbortController();
  const opts={signal:controller.signal};
  function refresh(){
    clearInterval(timer);
    button.textContent=paused?'Play slideshow':'Pause slideshow';
    button.setAttribute('aria-label',button.textContent);
    if(announcement)announcement.setAttribute('aria-live',paused?'polite':'off');
    if(!paused&&!hovered&&!document.hidden&&!motion.matches)timer=setInterval(()=>{
      if(!surface.isConnected){cleanup();return;}
      advance();
    },2500);
  }
  function cleanup(){clearInterval(timer);controller.abort();}
  button.addEventListener('click',()=>{paused=!paused;refresh();},opts);
  surface.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){hovered=true;refresh();}},opts);
  surface.addEventListener('pointerleave',()=>{hovered=false;refresh();},opts);
  surface.addEventListener('pointerdown',event=>{if(event.target!==button){paused=true;refresh();}},opts);
  surface.addEventListener('focusin',event=>{if(event.target!==button){paused=true;refresh();}},opts);
  document.addEventListener('visibilitychange',refresh,opts);
  document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(surface))cleanup();},opts);
  motion.addEventListener('change',()=>{paused=motion.matches;refresh();},opts);
  refresh();
}
function initializeFrozenHeroes(){
  document.querySelectorAll('[data-hero-slideshow]').forEach(surface=>{
    if(surface.dataset.initialized)return;
    surface.dataset.initialized='true';
    const frames=JSON.parse(surface.querySelector('[data-hero-frames]').textContent);
    const img=surface.querySelector('img');
    const names=['front','side','back'];let index=0;
    frames.forEach(src=>{const preload=new Image();preload.src=src;});
    const slide=frozenSlider(img);
    frozenAutoplay(surface,()=>{index=(index+1)%frames.length;slide(frames[index],'Light blue Frozen Snow Pants — '+names[index]+' view');});
  });
}
function jacketSlug(value){return String(value).toLowerCase().trim().replace(/\s+/g,'-');}
function initializeJacketProduct(root){
  if(root.dataset.initialized)return;
  let variants=[];
  try{variants=JSON.parse(root.querySelector('[data-jacket-variants]').textContent);}catch(error){console.error('FROZEN variant data could not be read',error);}
  let images={};
  const imageMap=root.querySelector('[data-jacket-image-map]');
  const shellProductImages=imageMap?[...imageMap.querySelectorAll('[data-shell-product-image]')]:[];
  if(shellProductImages.length){
    const scores={};
    shellProductImages.forEach(entry=>{
      const source=decodeURIComponent(entry.dataset.filename||'').toLowerCase();
      const match=source.match(/clean-shell-(ice-blue|white|red|beige|pink|black|navy-blue)-logo-(ice-blue|white|red|beige|pink|black|navy-blue)-(front|back)(-v3|-v2)?/);
      if(!match)return;
      const jacket=match[1]==='ice-blue'?'light-blue':match[1],logo=match[2]==='ice-blue'?'light-blue':match[2],view=match[3],score=match[4]==='-v3'?3:match[4]==='-v2'?2:1,key=`${jacket}|${logo}|${view}`;
      if(!images[jacket])images[jacket]={front:{},back:{}};
      if(!scores[key]||score>scores[key]){images[jacket][view][logo]=entry.dataset.url||null;scores[key]=score;}
    });
  }else if(imageMap){
    imageMap.querySelectorAll('[data-jacket-image-entry]').forEach(entry=>{
      const jacket=entry.dataset.jacket,logo=entry.dataset.logo;
      if(!images[jacket])images[jacket]={front:{},back:{}};
      images[jacket].front[logo]=entry.dataset.front||null;
      images[jacket].back[logo]=entry.dataset.back||null;
    });
  }else{
    try{images=JSON.parse(root.querySelector('[data-jacket-images]').textContent);}catch(error){console.error('FROZEN image data could not be read',error);images={};}
  }
    const select=root.querySelector('[data-jacket-select]'),main=root.querySelector('.mainpic'),highVariant=root.hasAttribute('data-jacket-high-variant')||!select||!select.options;
  const labels={'light-blue':'Light Blue',white:'White',red:'Red',beige:'Beige',pink:'Pink',black:'Black','navy-blue':'Navy Blue'};
  const viewNames=root.dataset.jacketViews==='2'?['Front','Back']:['Front','Side','Back'];
  let jacket=root.dataset.initialJacket||'light-blue',logo=root.dataset.initialLogo||'light-blue',size=(root.dataset.initialSize||'XS').toUpperCase(),view=0;
    const jacketButtons=[...root.querySelectorAll('[data-jacket-color]')],logoButtons=[...root.querySelectorAll('[data-logo-color]')],sizeButtons=[...root.querySelectorAll('[data-jacket-size]')],thumbs=[...root.querySelectorAll('[data-jacket-thumb]')];
    const findVariant=()=>variants.find(v=>jacketSlug(v.options[0])===jacket&&jacketSlug(v.options[1])===logo&&String(v.options[2]).toUpperCase()===size);
    const fallbackVariant=()=>variants.find(v=>String(v.options[2]).toUpperCase()===size&&v.available)||variants.find(v=>v.available)||variants[0];
    function syncProperties(){
      const jacketProperty=root.querySelector('[data-jacket-property]'),logoProperty=root.querySelector('[data-logo-property]'),sizeProperty=root.querySelector('[data-size-property]');
      if(jacketProperty)jacketProperty.value=labels[jacket]||jacket;
      if(logoProperty)logoProperty.value=labels[logo]||logo;
      if(sizeProperty)sizeProperty.value=size;
    }
    function highVariantUrl(){
      const jacketButton=jacketButtons.find(button=>button.dataset.jacketColor===jacket);
      const logoButton=logoButtons.find(button=>button.dataset.logoColor===logo);
      const sizeButton=sizeButtons.find(button=>button.dataset.jacketSize===size);
      const ids=[jacketButton,logoButton,sizeButton].map(button=>button&&button.dataset.optionValueId).filter(Boolean);
      if(ids.length!==3)return null;
      const url=new URL(location.href);
      url.searchParams.delete('variant');
      url.searchParams.set('option_values',ids.join(','));
      return url;
    }
    let highVariantRequest=0,highVariantController=null;
    async function loadHighVariant(){
      const url=highVariantUrl();
      if(!url)return;
      const request=++highVariantRequest;
      if(highVariantController)highVariantController.abort();
      highVariantController=new AbortController();
      root.classList.add('is-loading-variant');
      root.setAttribute('aria-busy','true');
      root.querySelector('[data-jacket-add]').disabled=true;
      root.querySelector('[data-jacket-add]').textContent='UPDATING…';
      root.querySelector('[data-jacket-express]').hidden=true;
      root.querySelector('[data-jacket-status]').textContent='Updating your selection…';
      try{
        const response=await fetch(url.toString(),{credentials:'same-origin',headers:{Accept:'text/html'},signal:highVariantController.signal});
        if(!response.ok)throw new Error('The selected combination could not be loaded.');
        const page=new DOMParser().parseFromString(await response.text(),'text/html');
        const fresh=page.querySelector('[data-jacket][data-jacket-high-variant]');
        if(!fresh)throw new Error('The selected combination could not be found.');
        if(request!==highVariantRequest)return;
        const fallback=fallbackVariant(),selectedId=fresh.dataset.selectedVariantId||(fallback&&fallback.id)||'';
        const selectedAvailable=fresh.dataset.selectedVariantId?fresh.dataset.selectedAvailable:String(!!(fallback&&fallback.available));
        root.dataset.selectedVariantId=selectedId;
        root.dataset.selectedAvailable=selectedAvailable;
        const idField=root.querySelector('[name="id"]');
        if(idField)idField.value=selectedId;
        const freshPrice=fresh.querySelector('[data-jacket-price]');
        if(freshPrice)root.querySelector('[data-jacket-price]').textContent=freshPrice.textContent;
        history.replaceState({},'',url);
        sync(false);
      }catch(error){
        if(error.name!=='AbortError')location.assign(url.toString());
      }finally{
        if(request===highVariantRequest){root.classList.remove('is-loading-variant');root.removeAttribute('aria-busy');}
      }
    }
  function gallerySource(group,i){const name=viewNames[i].toLowerCase(),set=group[name];return set&&typeof set==='object'?set[logo]:set;}
  function gallery(){const group=images[jacket]||{},src=gallerySource(group,view);if(src)main.src=src;main.alt=`${labels[jacket]} jacket, ${labels[logo]} logo and zippers — ${viewNames[view].toLowerCase()} view`;root.querySelector('[data-jacket-view]').textContent=`${viewNames[view]} · ${view+1} / ${viewNames.length}`;thumbs.forEach((a,i)=>{const s=gallerySource(group,i);if(s){a.href=s;a.querySelector('img').src=s;}a.setAttribute('aria-current',String(i===view));});}
    function sync(updateUrl=true){
      let variant=null,available=false;
      if(highVariant){
        available=root.dataset.selectedAvailable==='true';
      }else{
        variant=findVariant();
        available=!!variant&&variant.available;
        select.value=variant?String(variant.id):'';
        const option=[...select.options].find(item=>variant&&item.value===String(variant.id));
        if(option)root.querySelector('[data-jacket-price]').textContent=option.dataset.price;
      }
      root.querySelector('[data-jacket-add]').disabled=!available;
      root.querySelector('[data-jacket-add]').textContent=available?'ADD TO CART':highVariant||variant?'SOLD OUT':'UNAVAILABLE';
      root.querySelector('[data-jacket-express]').hidden=!available;
      root.querySelector('[data-jacket-status]').textContent=available?'':highVariant||variant?'This combination is sold out.':'This combination is unavailable.';
      jacketButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.jacketColor===jacket)));
      logoButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.logoColor===logo)));
      sizeButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.jacketSize===size)));
      root.querySelector('[data-jacket-color-label]').textContent=labels[jacket];
      root.querySelector('[data-logo-color-label]').textContent=labels[logo];
      syncProperties();
      if(updateUrl&&!highVariant&&variant){const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);}
    }
    jacketButtons.forEach(button=>button.addEventListener('click',()=>{jacket=button.dataset.jacketColor;view=0;gallery();if(highVariant)loadHighVariant();else sync();}));
    logoButtons.forEach(button=>button.addEventListener('click',()=>{logo=button.dataset.logoColor;view=0;gallery();if(highVariant)loadHighVariant();else sync();}));
    sizeButtons.forEach(button=>button.addEventListener('click',()=>{size=button.dataset.jacketSize;if(highVariant)loadHighVariant();else sync();}));
    thumbs.forEach((anchor,index)=>anchor.addEventListener('click',event=>{event.preventDefault();view=index;gallery();}));
    root.querySelector('[data-jacket-prev]').addEventListener('click',()=>{view=(view+viewNames.length-1)%viewNames.length;gallery();});
    root.querySelector('[data-jacket-next]').addEventListener('click',()=>{view=(view+1)%viewNames.length;gallery();});
    root.querySelector('.gallery-stage').addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){view=(view+viewNames.length-1)%viewNames.length;gallery();}if(event.key==='ArrowRight'){view=(view+1)%viewNames.length;gallery();}});
    root.dataset.initialized='true';gallery();sync(false);
}
function initializeFrozenProducts(){document.querySelectorAll('.product:not([data-beanie]):not([data-jacket])').forEach(initializeFrozenProduct);document.querySelectorAll('[data-jacket]').forEach(initializeJacketProduct);initializeFrozenHeroes();}
  if(typeof document!=='undefined'){
    document.addEventListener('submit',frozenAjaxCartSubmit);
    document.addEventListener('DOMContentLoaded',initializeFrozenProducts);
  document.addEventListener('shopify:section:load',initializeFrozenProducts);
}
if(typeof module!=='undefined')module.exports={frozenColor,frozenSize,frozenMatch};
